import { TicketData } from '@/common/types/support/ticket.type'
import { SupportTicketAvailableUserWithRelationType } from '@/features/support/internal/types/supportTicketAvailableUser.type'

export const updateUserTicketsRelationType = ({
  users,
  supportTicketData,
}: {
  users: SupportTicketAvailableUserWithRelationType[]
  supportTicketData?: TicketData
}) =>
  (supportTicketData?.user_tickets || [])
    .filter((existingUserTicket) => {
      const updatedUser = users?.find((user) => user.id === existingUserTicket.user.id)
      return updatedUser && updatedUser.relationType !== existingUserTicket.relation_type
    })
    .map((userTicket) => {
      const updatedUser = users?.find((user) => user.id === userTicket.user.id)!
      return {
        id: userTicket.id,
        user_id: userTicket.user.id,
        user_type: 'Admin::User',
        relation_type: updatedUser.relationType,
      }
    })
